// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const chien_pao: PokeData = {
  "id": 1002,
  "name": "chien-pao",
  "height": 19,
  "weight": 1522,
  "base_experience": 285,
  "types": [
    PokeType.DARK,
    PokeType.ICE
  ],
  "api_moves": [
    "swords-dance",
    "mist",
    "recover",
    "haze",
    "spite",
    "powder-snow",
    "icy-wind",
    "mean-look",
    "sheer-cold",
    "payback",
    "sucker-punch",
    "dark-pulse",
    "night-slash",
    "ice-shard",
    "sacred-sword",
    "icicle-crash",
    "throat-chop",
    "ruination",
    "snowscape"
  ],
  "moves": [
    "sheer-cold",
    "dark-pulse",
    "night-slash",
    "ice-shard",
    "phantom-force",
    "quash",
    "lash-out",
    "pursuit",
    "blizzard",
    "ice-wave",
    "crunch",
    "night-daze",
    "snatch"
  ],
  "evolution_chain": {
    "id": 530,
    "item": null,
    "species": [
      {
        "name": "chien-pao",
        "order": 995,
        "types": [
          PokeType.DARK,
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 92,
    "speed": 163,
    "ability_power": 145
  },
  "stat_changes": [],
  "catch_rate": 6,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
